import {Grid, GridItem, Hr, Paragraph} from '@constellation/core';
import {Fragment, memo} from 'react';
import {styled} from 'styled-components';
import {IMAGES} from '../../../../../utils/constants/image.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import ReactImageLazyLoad from '../../../../common/ReactImageLazyLoad/index.js';

const ImageWrapper = styled.span`
  margin-right: 0px;
`;

const OutputHeader = memo(() => (
  <Fragment>
    <Hr marginBottom='04' marginTop='07' />
    <Grid>
      <GridItem lg={2} md={12}>
        <ImageWrapper>
          <ReactImageLazyLoad
            alt={getPsrLabel('cardPaymentServicesDetails.outputHeader.logoAlt')}
            imageSrc={IMAGES.psrLogoUrlSVG}
          />
        </ImageWrapper>
      </GridItem>
      <GridItem lg={10} md={12}>
        <Paragraph marginBottom='none'>
          {getPsrLabel(
            'cardPaymentServicesDetails.outputHeader.headerText.text1'
          )}
        </Paragraph>
        <Paragraph marginBottom='none'>
          {getPsrLabel(
            'cardPaymentServicesDetails.outputHeader.headerText.text2'
          )}
        </Paragraph>
        <Paragraph marginBottom='none'>
          {getPsrLabel(
            'cardPaymentServicesDetails.outputHeader.headerText.text3'
          )}
        </Paragraph>
      </GridItem>
    </Grid>
    <Hr marginBottom='06' marginTop='04' />
  </Fragment>
));

export default OutputHeader;
